import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import Button from '../../components/button';
import CheckboxDefault from '../../components/checkbox';
import Headline5 from '../../components/headings/Headline5';
import Headline6 from '../../components/headings/Headline6';
import Modal from '../../components/modal'
import RadioDefault from '../../components/radioGroup';
import { Error } from "@progress/kendo-react-labels";
import Styles from './styles.module.scss'

export type QuestionireForm = {
    '1'?: string;
    '2'?: string;
    '3'?: string;
    '4'?: string;
    '5'?: string;
    '6'?: string;
    '7'?: string;
    '8'?: string;
    '9'?: string;
    '10'?: string;


}

interface Props {
    onClose?: any;
    questions?: any;
    clickHandler?: any;
}


const Questionire: React.FC<Props> = ({
    onClose,
    questions,
    clickHandler
}) => {
    const loginId: string = localStorage.getItem('loginId') || ''
    let threeValue: any = [];
    let fourValue: any = [];
    const formOptions = {
      }
    
      const {
        handleSubmit,
        setValue,
      } = useForm<QuestionireForm>(formOptions);

    const [one, setOne] = useState<any>()
    const [two, setTwo] = useState<any>()
    const [five, setFive] = useState<any>()
    const [six, setSix] = useState<any>()
    const [seven, setSeven] = useState<any>()
    const [eight, setEight] = useState<any>()
    const [nine, setNine] = useState<any>()
    const [ten, setTen] = useState<any>()
    const [eleven, setEleven] = useState<any>()
    const [error, setError] = useState<{
        one: string;
        two: string;
        three: string;
        four: string;
        five: string;
        six: string;
        seven: string;
        eight: string;
        nine: string;
        ten: string;
        eleven: string;
      }>({
        one: "",
        two: "",
        three: "",
        four: "",
        five: "",
        six: "",
        seven: "",
        eight: "",
        nine: "",
        ten: "",
        eleven: "",
      });   
   
    const onChange = (e: any, name: string, questionNum: any) => {
   
       //setError({one:'',two:'', three:'', four:'', five:'', six:'', seven:'', eight:'', nine:'', ten:'', eleven:''})
      error.one = ''
      error.two = ''
      error.three = ''
      error.four = ''
      error.five = ''
      error.six = ''
      error.seven = ''
      error.eight = ''
      error.nine = ''
      error.ten = ''
      error.eleven = ''

        if (name === 'checkbox') {
          if (e.target.value) {
              let target = e.target.name
                if (questionNum === '3') {
                  threeValue = [...threeValue, target];
                    setValue('3', threeValue)
                }
                if (questionNum === '4') {
                  fourValue = [...fourValue, e.target.name];
                    setValue('4', fourValue)

                }               
            }
            else {    
                if (questionNum === '3') {
                                   
                    threeValue = threeValue.filter((item: string) => item !== e.target.name);
                    setValue('3', threeValue)
                }
                if (questionNum === '4') {
                    fourValue = fourValue.filter((item: string) => item !== e.target.name);  
                    setValue('4', fourValue)

                }
            }

        }
        else {
            setValue(questionNum, e.value)
            checkRadio(questionNum, e.value)
        }
    }

    const onSubmit = (data: any) => { 

        let isError: boolean = false;

        if (!data[1]) {
            error.one = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[2]) {
            error.two = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[3]) {
            error.three = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[4]) {
            error.four = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[5]) {
            error.five = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[6]) {
            error.six = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[7]) {
            error.seven = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[8]) {
            error.eight = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[9]) {
            error.nine = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[10]) {
            error.ten = "Field is required";
            setError({ ...error });
            isError = true;
          }
          if (!data[11]) {
            error.eleven = "Field is required";
            setError({ ...error });
            isError = true;
          }
        let body = {
            loginId: loginId,
            surveyResult: {
              "1": [data[1]],
              "2": [data[2]],
              "3": [data[3]],
              "4": [data[4]],
              "5": [data[5]],
              "6": [data[6]],
              "7": [data[7]],
              "8": [data[8]],
              "9": [data[9]],
              "10": [data[10]],
              "11": [data[11]]         
            }
        }
      if (!isError) {        
         clickHandler(body) 
        }
    }

    const dataConversion = (data: any) => {
        let convertedData = data && data.map((item: any, key: number) => { return { label: item, value: item } })
        return convertedData
    }
    
    const checkRadio = (num: string, value: string) => {
        switch (num) {
            case '1':
                setOne(value)
                break;
            case '2':
                setTwo(value)
                break;
            case '5':
                setFive(value)
                break;
            case '6':
                setSix(value)
                break;
            case '7':
                setSeven(value)
                break;
            case '8':
                setEight(value)
                break;
            case '9':
                setNine(value)
                break;
            case '10':
                setTen(value)
                break;
            case '11':
                setEleven(value)
        }
    }

    return (
      
        <Modal size='medium' title='Submit' onClose={onClose}>
            <div className="questionnaireWrap">
            <div className="questionnaireHead">
            <Headline5>Questionnaire</Headline5>
            <div className="questionSubtext">
              Take the survey to stand out among the pool of the candidates
            </div>
          </div>
          <div className="qstnInfo">
            You will be redirected to the test post submitting this
            questionnaire
          </div>
            <form>
            <div className="form-group">
            <Headline6>1. {questions && questions[0].question }  </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[0] && questions[0].question_options && dataConversion(questions[0].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '1')}
                        name='1'
                        checked={one}
                    />
                         <Error>{error?.one}</Error>

            </div>
            <div className="form-group">
            <Headline6>2. {questions && questions[1].question }  </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[1] && questions[1].question_options && dataConversion(questions[1].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '2')}
                        name='2'
                        checked={two}
                    />
                         <Error>{error?.two}</Error>

            </div>
            <div className="form-group">
            <Headline6>3. {questions && questions[2].question } </Headline6>
            <div className={Styles.positionStatusList}>
                {questions && questions[2] && questions[2].question_options && questions[2].question_options.answers && questions[2].question_options.answers.map((item: any, key: number) => {
                    return (
                      <div className={Styles.positionItem}>
                        <CheckboxDefault
                            onchange={(e: any) => onChange(e, 'checkbox', '3')}
                            label={item}
                            name={item}
                            key={key}
                    />
                      </div>
                    )
                })              
                        }
                                      <Error>{error?.three}</Error>
              </div>
            </div>
            <div className="form-group">
            <Headline6>4. {questions && questions[3].question } </Headline6>
            <div className={Styles.positionStatusList}>
            {questions && questions[3] && questions[3].question_options && questions[3].question_options.answers && questions[3].question_options.answers.map((item: any, key: number) => {
                    return (
                      <div className={Styles.positionItem}>
                        <CheckboxDefault
                        onchange={(e: any) => onChange(e, 'checkbox', '4')}
                            label={item}
                            name={item}
                            key={key}
                    />
                    </div>
                    )
                })              
                }
                <Error>{error?.four}</Error>
            </div>    
            </div>
            <div className="form-group">
            <Headline6>5. {questions && questions[4].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[4] && questions[4].question_options && dataConversion(questions[4].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '5')}
                    checked={five}
                />
                <Error>{error?.five}</Error>
         
            </div>
            <div className="form-group">
            <Headline6>6. {questions && questions[5].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[5] && questions[5].question_options && dataConversion(questions[5].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '6')}
                    checked={six}
                />
              <Error>{error?.six}</Error>
            </div>
            <div className="form-group">
            <Headline6>7. {questions && questions[6].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[6] && questions[6].question_options && dataConversion(questions[6].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '7')}
                    checked={seven}
                />
              <Error>{error?.seven}</Error>
            </div>
            <div className="form-group">
            <Headline6>8. {questions && questions[7].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[7] && questions[7].question_options && dataConversion(questions[7].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '8')}
                    checked={eight}
                        />
                                      <Error>{error?.eight}</Error>

            </div>
            <div className="form-group">
            <Headline6>9. {questions && questions[8].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[8] && questions[8].question_options && dataConversion(questions[8].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '9')}
                    checked={nine}
                />
                         <Error>{error?.nine}</Error>

            </div>
            <div className="form-group">
            <Headline6>10. {questions && questions[9].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[9] && questions[9].question_options && dataConversion(questions[9].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '10')}
                    checked={ten}

                />
                         <Error>{error?.ten}</Error>

                </div>
                <div className="form-group">
            <Headline6>11. {questions && questions[10].question } </Headline6>

                <RadioDefault
                    layout='vertical'
                    data={questions && questions[10] && questions[10].question_options && dataConversion(questions[10].question_options.answers)}
                    handleChange={(e: any) => onChange(e, 'radio', '11')}
                    checked={eleven}

                />
                         <Error>{error?.eleven}</Error>

            </div>
            <div className="popupAction">
              <Button onClick={onClose} type="submit" variant="secondary" size="small">Cancel</Button>
              <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="small">Save</Button>
                </div>
                </form>

                </div>
    </Modal>
  )
}

export default Questionire